// extracted by mini-css-extract-plugin
export var checkboxWrapper = "index-module--checkboxWrapper--0gGQU";
export var headerContainer = "index-module--headerContainer--spgHj";
export var iconChecked = "index-module--iconChecked--fl-1H";
export var iconNormal = "index-module--iconNormal--mZGsr";
export var tagContainer = "index-module--tagContainer--9wK+L";
export var tagList = "index-module--tagList--YS6dh";
export var tipArea = "index-module--tipArea--DgQpz";
export var tipTitle = "index-module--tipTitle--sqkrG";